
  import type { PropType } from 'vue';
  import { defineComponent, unref } from 'vue';

  import { CHART_ZOOM_TOOLBOX_ICON_PATHS } from './chartZoomToolbox';
  import type { TEChartsChartZoomToolbarApi } from './useEChartsChartZoom';

  export default defineComponent({
    name: 'EChartsChartZoomToolbar',
    props: {
      zoomApi: {
        type: Object as PropType<TEChartsChartZoomToolbarApi>,
        required: true,
      },
    },
    computed: {
      buttons() {
        const mode = unref(this.zoomApi.interactionMode);

        return [
          {
            id: 'zoomIn',
            title: 'Приблизить',
            path: CHART_ZOOM_TOOLBOX_ICON_PATHS.zoomIn,
            active: false,
            onClick: () => this.zoomApi.zoomIn(),
          },
          {
            id: 'zoomOut',
            title: 'Уменьшить',
            path: CHART_ZOOM_TOOLBOX_ICON_PATHS.zoomOut,
            active: false,
            onClick: () => this.zoomApi.zoomOut(),
          },
          {
            id: 'zoomSelect',
            title: 'Лупа',
            path: CHART_ZOOM_TOOLBOX_ICON_PATHS.zoomSelect,
            active: mode === 'zoom',
            onClick: () => this.zoomApi.activateZoomSelectMode(),
          },
          {
            id: 'pan',
            title: 'Перемещение',
            path: CHART_ZOOM_TOOLBOX_ICON_PATHS.pan,
            active: mode === 'pan',
            onClick: () => this.zoomApi.activatePanMode(),
          },
          {
            id: 'reset',
            title: 'Сбросить',
            path: CHART_ZOOM_TOOLBOX_ICON_PATHS.home,
            active: false,
            onClick: () => this.zoomApi.resetZoom(),
          },
        ];
      },
    },
  });
